module.exports = __webpack_public_path__ + "static/img/about-us.e22d4b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fullwidth/about-us.png
// module id = SUmM
// module chunks = 1